import { useState } from "react";
import { useForm } from "react-hook-form";
import { dividernew, envelopenew, flag, lock, loginpic, logo, passeye, Vector } from "../../assets/imagesPath";
import AuthRightSection from "../AuthRightSection/AuthRightSection";
import { useLoginUserMutation, useRegisterUserMutation } from "../../services/Api";
import { useDispatch } from "react-redux";
import { loggedIn } from "../../redux/AuthSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AuthForm = ({ formType }) => {
    const [registerUser, { isLoading: isRegistering }] = useRegisterUserMutation();
    const [loginUser, { isLoading: isLoggingIn }] = useLoginUserMutation();
    const { register, handleSubmit, reset, formState: { errors }, } = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const [showPassword, setShowPassword] = useState(false);
    // const [language, setLanguage] = useState("en");
    const [loginStates, setLoginStates] = useState({
        showPassword: false,
        language: 'en',
    })
    const updateLoginStates = (key, value) => {
        setLoginStates(prevState => ({ ...prevState, [key]: value }))
    }


    const onSubmit = async (data) => {
        console.log("Form Data:", data);

        try {
            let response;
            if (formType === "signup") {
                response = await registerUser(data).unwrap();
                toast.success("Account created successfully!");
                navigate('/login');
            } else {
                response = await loginUser(data).unwrap();
                toast.success("Logged in successfully!");
                navigate('/basic-info');
            }

            console.log("API Response:", response);
            dispatch(loggedIn(response));

        } catch (error) {
            console.error("Error:", error);
            toast.error(error?.data?.message || "Something went wrong!");
        }

        reset();
    };

    return (
        <div className="min-h-screen flex">
            <div className="w-full md:w-1/2 flex flex-col p-8 md:p-20 bg-white">
                <div className="flex justify-between items-center mb-6">
                    <img src={logo} alt="Brand Logo" className="h-20 w-20" />
                    <div className="relative inline-flex items-center">
                        <img src={flag} alt="Flag" className="absolute left-4 h-[12px] smallScreens:h-4" />
                        <select
                            value={loginStates.language}
                            onChange={(e) => updateLoginStates('language', e.target.value)}
                            className="pl-12 pr-4 py-3 rounded-lg bg-[#F8FBFF] font-bold text-[1.2rem]"
                        >
                            <option value="en">English (US)</option>
                            <option value="es">German</option>
                            <option value="fr">French</option>
                        </select>
                    </div>
                </div>
                <h1 className="text-[3.7rem] font-semibold mt-6">
                    {formType === "signup" ? "Hi, Welcome to SBAA " : "Hi, Welcome Back!"}
                </h1>
                <p className="text-gray-500 text-[1.5rem] mt-3">
                    {formType === "signup" ? "Create an account and enjoy starting Apexify" : "Login to your account to enjoy"}
                </p>
                <button className="flex items-center justify-center gap-2 w-full mt-6 p-4 border rounded-md hover:bg-gray-100 transition">
                    <img src="https://www.google.com/favicon.ico" alt="Google" className="w-8 h-8" />
                    <span className="text-[1.4rem] font-bold">
                        {formType === "signup" ? "Sign up with Google" : "Sign in with Google"}
                    </span>
                </button>
                <div className="flex items-center justify-center w-full my-6 text-[#8F95B2] text-[1.2rem]">
                    <img src={dividernew} alt="divider" className="flex-1 h-[2px]" />
                    <span className="mx-4 whitespace-nowrap">or {formType === "signup" ? "Sign up" : "Sign in"} with Email</span>
                    <img src={dividernew} alt="divider" className="flex-1 h-[2px]" />
                </div>

                <form className="space-y-8" onSubmit={handleSubmit(onSubmit)}>
                    {formType === "signup" && (
                        <div className="relative">
                            <label className="block text-[1.2rem] font-medium">Full Name</label>
                            <div className="relative mt-3">
                                <img src={Vector} alt="email" className="absolute left-3 top-1/2 transform -translate-y-1 w-6 h-6" />
                                <input
                                    type="text"
                                    placeholder="John Doe"
                                    {...register("name", {
                                        required: "Name is required.",
                                        pattern: {
                                            value: /^[A-Za-z\s]+$/,
                                            message: "Name must contain only letters.",
                                        }
                                    })}
                                    className="w-full p-6 px-12 border rounded-md mt-3 text-[1.2rem]"
                                // required
                                />
                                {errors.name && (
                                    <p className="text-red-500 text-sm mt-1">
                                        {errors.name.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                    <div className="relative">
                        <label className="block text-[1.2rem] font-medium">Email address</label>
                        <div className="relative mt-3">
                            <img src={envelopenew} alt="email" className="absolute left-3 top-1/2 transform -translate-y-1 w-7 h-7" />
                            <input
                                type="email"
                                placeholder="john@example.com"
                                {...register("email", {
                                    required: "Email is required.",
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Invalid email address.",
                                    },
                                })}
                                className="w-full p-6 px-12 border rounded-md mt-3 text-[1.2rem]"
                            // required
                            />
                            {errors.email && (
                                <p className="text-red-500 text-sm mt-1">
                                    {errors.email.message}
                                </p>
                            )}

                        </div>
                    </div>

                    <div className="relative">
                        <label className="block text-[1.2rem] font-medium">Password</label>
                        <div className="relative mt-3">
                            <img src={lock} alt="password" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-7 h-7" />
                            <input
                                type={loginStates.showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                {...register("password", {
                                    required: "Password is required.",
                                    minLength: {
                                        value: 6,
                                        message: "Password must be at least 6 characters long.",
                                    },
                                    pattern: {
                                        value: /^(?=.*[A-Z])(?=.*\d).{6,}$/,
                                        message: "Must contain at least 1 uppercase letter & 1 number.",
                                    },
                                })}
                                className="w-full p-6 px-12 border rounded-md text-[1.2rem]"
                            // required
                            />
                            <button
                                type="button"
                                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                onClick={() => updateLoginStates('showPassword', !loginStates.showPassword)}
                            >
                                <img src={passeye} alt="Show Password" className="w-8 h-8" />
                            </button>
                            {errors.password && (
                                <p className="text-red-500 text-sm mt-1">
                                    {errors.password.message}
                                </p>
                            )}
                        </div>
                    </div>
                    {formType !== "signup" && (
                        <div className="flex justify-between items-center">
                            <label className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    {...register("remember", { required: false })}
                                    className="accent-[#173363]"
                                />
                                <span className="text-[1.2rem]">Remember me</span>
                            </label>
                            <a href="#" className="text-[#173363] hover:underline text-[1.2rem]">
                                Forgot your password?
                            </a>
                        </div>
                    )}
                    {formType === "signup" && (
                        <div className="flex items-center space-x-2 mt-4">
                            <input
                                type="checkbox"
                                {...register("terms", { required: false })}
                                className="accent-[#173363]"
                            />
                            <label className="text-[1.2rem]">
                                I agree to the{" "}
                                <a href="/terms" className="text-[#173363] hover:underline">
                                    Terms & Conditions
                                </a>
                            </label>
                        </div>
                    )}

                    <button className="w-full bg-[#173363] text-[1.4rem] font-semibold text-white p-4 rounded-lg">
                        {formType === "signup" ? "Sign Up" : "Log In"}
                    </button>
                </form>
                <p className="text-[1.2rem] text-gray-500 mt-6">
                    {formType === "signup" ? "Already have an account?" : "Not registered yet?"}{" "}
                    <a href={formType === "signup" ? "/login" : "/sign-up"} className="text-[#173363] hover:underline">
                        {formType === "signup" ? "Log in" : "Create an Account"}
                    </a>
                </p>
            </div>
            <AuthRightSection
                heading="Hi, Welcome Back!"
                subText="Login to your account to enjoy"
                image={loginpic}
            />
        </div>
    );
};

export default AuthForm;
